export default "__VITE_ASSET__Bz2U8pRg__"